import { createContext } from 'react';

const AppContext = createContext({
  isLoggedIn: false,
  isLoading: false,
  access: [],
  user: {},
  type: '',
  client_options: {},
  loginHandler: (type, email, password) => {},
  logoutHandler: () => {},
  loadingHandler: () => {},
  checkTokenHandler: () => {},
  clientFilterHandler: (id) => {},
  selectedClientID: null,
  siteFilterHandler: (id) => {},
  selectedSiteID: null,
  fetchClientsOptions: (type) => {},
  site_options: {},
  fetchSiteOptions: (type) => {},
});

export default AppContext;
